import clsx from 'clsx';
import { SyntheticEvent } from 'react';
import { useDispatch } from 'react-redux';

import { IEntityComponentProps } from '~interfaces/props';
import { ControlActions } from '~store/actions';
import { getAbsoluteUrl } from '~store/getter';

export interface IVideoProps extends IEntityComponentProps {
  preload: 'false' | 'metadata' | 'none';
  controls: boolean;
  onPlay: (e: SyntheticEvent<HTMLVideoElement>) => void;
}

export const Video = (props: IVideoProps) => {
  const { preload, controls, className, extraData } = props;
  let { webm, mpeg4, poster } = extraData;
  mpeg4 = mpeg4 && mpeg4[0] ? mpeg4[0] : mpeg4;
  webm = webm && webm[0] ? webm[0] : webm;
  poster = poster && poster[0] ? poster[0] : poster;

  const dispatch = useDispatch();

  const onPlay = (e: SyntheticEvent<HTMLVideoElement>) => {
    const element = e.target as HTMLVideoElement;
    const payload: PlayVideo = {
      currentSrc: element.currentSrc,
      currentTime: element.currentTime,
      duration: element.duration,
    };
    dispatch(ControlActions.playVideo(payload));
  };

  const sources = [
    {
      type: 'video/webm',
      src: (webm as Entity) && (webm as Entity).attributes && (webm as Entity).attributes.url,
    },
    {
      type: 'video/mp4',
      src: mpeg4 && (mpeg4 as Entity).attributes && (mpeg4 as Entity).attributes.url,
    },
  ];

  const classes = clsx(className);

  return (
    <video
      preload={preload}
      controls={controls}
      poster={poster && (poster as Entity).attributes && getAbsoluteUrl((poster as Entity).attributes.url)}
      onPlay={e => onPlay(e)}
      className={classes}
    >
      {sources.map(
        source => source.src && <source key={source.type} type={source.type} src={getAbsoluteUrl(source.src)} />,
      )}
      {`I'm sorry, your browser doesn't support HTML5 video in WebM or MP4.`}
    </video>
  );
};

export default Video;
